<template>
  <v-card
    v-if="!pageloading"
    class="institution-services-card"
    :outlined="!!showInstitutionServiceCard"
  >
    <v-card-text v-if="showInstitutionServiceCard">
      <v-row>
        <v-col cols="12" md="6">
          <el-text-field
            @keyup.enter.native="search ? searchDataReq() : clearData()"
            label="Paslaugos pavadinimas"
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Paslaugos pavadinimas"
            v-model="search"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-button
            title="Ieškoti"
            style="height: 40px"
            icon="ieškoti"
            class="mr-2"
            :loading="loading"
            @click.native.stop="search ? searchDataReq() : clearData()"
            color="primary"
          />
          <el-button
            title="Išvalyti"
            icon="išvalyti"
            style="height: 40px"
            :loading="loading"
            @click.native="clearData()"
            color="secondary"
          />
        </v-col>
        <!-- items -->
        <v-col
          class="institution-services-col"
          cols="12"
          md="12"
        >
          <institution-services-items
            v-if="!loading"
            :level="1"
            :allData="getListData"
            :formData="getListData"
            :activeServices="getAddedServices()"
          ><div v-observe-visibility="handleInfinityScroll"/>
          </institution-services-items>
          <v-skeleton-loader
            v-if="loading"
            type="list-item-three-line"
          ></v-skeleton-loader>
        </v-col>

        <v-col @mouseenter="setTooltipParam()" cols="12" md="4">
          <a v-if="!showTooltip" @click="emmitClearAll()">{{ $t('Atžymėti pažymėtas paslaugas') }}</a>
          <v-tooltip v-else max-width="300px" top>
            <template v-slot:activator="{ on, attrs }">
              <a  v-on="on" v-bind="attrs" @click="emmitClearAll()">{{ $t('Atžymėti pažymėtas paslaugas') }}</a>
            </template>
            <span>{{$t('Pažymėta(-os) paslauga(-os) jau pridėta(-os) į pasirinktų paslaugų sąrašą. Jei norite keisti pasirinkimą, pirmiausia pašalinkite paslaugą(-as) iš pasirinktų paslaugų sąrašo.')}}</span>
          </v-tooltip>
        </v-col>
        <v-col style="text-align: end" cols="12" md="8">
          <el-button
            title="Pridėti pažymėtas paslaugas"
            icon="pridėti"
            @click.native.stop="addSelected()"
            color="primary"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else-if="showInstitutionServiceCardByEmpty">
      <v-row>
        <v-col cols="12"
          ><span>{{
            $t(
              'Ieškoma institucija neturi registruoto paslaugų sąrašo. Ieškokite kitos institucijos arba norimai institucijai įveskite paslaugą pasirinkę kortelę "Įvesti paslaugą".'
            )
          }}</span></v-col
        >
      </v-row>
    </v-card-text>
  </v-card>
  <v-skeleton-loader v-else type="list-item-three-line"></v-skeleton-loader>
</template>

<script>
import InstitutionServicesItems from './InstitutionServicesItems'
import { transliterate as tr } from 'transliteration';
import Enums from '@/enums'

export default {
  name: 'InstitutionServicesCard',
  components: {
    InstitutionServicesItems,
  },
  props: {
    formData: [Object, Boolean, String, Number],
    institutionId: [String, Number],
    mainFilter: Boolean,
    providerType: String,
    addFilter: Boolean,
    customService: Boolean,
  },
  data() {
    return {
      listData: [],
      search: null,
      activeSearch: '',
      pageloading: false,
      loading: false,
      listloading: false,
      selected: 0,
      institutionData: {},
      data: [],
      page: 1,
      totalPages: 100,
      isEmpty: false,
      showTooltip: false,
    }
  },
  created() {
    this.loading = true
    
  },
  mounted(){
    this.getData(this.page)
  },

  computed: {
    getListData() {
      return this.listData
    },
    showInstitutionServiceCard() {
      return (
        !this.isEmpty &&
        !this.customService &&
        (this.mainFilter || this.institutionId || this.addFilter)
      )
    },
    showInstitutionServiceCardByEmpty() {
      return this.isEmpty
    },
    elValue: {
      get() {
        return this.formData
      },
      set(elValue) {
        this.$emit('formData', elValue)
      },
    },
  },
  methods: {
    setTooltipParam(){
      var classesNodeList = document.querySelectorAll(".item-selected-active")
      if(classesNodeList.length == 0 && this.getAddedServices().length > 0){
        this.showTooltip = true
      } else {
        this.showTooltip = false
      }
    },
    getAddedServices(){
      let activeServices = []
      this.formData.action_providers.map(provider =>{
        provider.services.map(service =>{
          activeServices.push(parseInt(service.action_id))
        })
      })
      return activeServices
    },
    handleInfinityScroll(isVisible) {
      if (!isVisible) {
        return;
      }
      if (this.page >= this.totalpage) {
        return;
      }
      this.page++;
      this.getData(this.page)
    },
    searchDataReq() {
      this.listData = []
      this.page = 1
      this.activeSearch = this.search
      this.loading = true
      this.getData(null)
    },
    loadMore(e) {
      let { scrollTop, clientHeight, scrollHeight } = e.target
      if (
        !this.loading &&
        !this.listloading &&
        scrollTop + clientHeight >= (scrollHeight * 4) / 5 &&
        this.page < this.totalPages
      ) {
        this.page++
        this.getData(this.page)
      }
    },
    //tree search
    searchChildrenData(items) {
      let includes = items.filter((item) => {
        let title = this.$i18n.locale === 'lt' ? item.title_lt : item.title_en
        let search = this.search.toLowerCase().split(' ')
        // title
        let includes_title = false
        search.every((element) => {
          includes_title = tr(title).toLowerCase().includes(tr(element))
          return includes_title ? false : true
        })
        // pasis_code
        let includes_pasis_code = false
        search.every((element) => {
          includes_pasis_code = item.pasis_code
            ? item.pasis_code.toLowerCase().includes(element)
            : false
          return includes_pasis_code ? false : true
        })
        // code
        let includes_code = false
        search.every((element) => {
          includes_code = item.code
            ? item.code.toLowerCase().includes(element)
            : false
          return includes_code ? false : true
        })
        // institution
        let includes_institution = false
        search.every((element) => {
          if(item.provider_type === "amn"){
            includes_institution = item.institution?.fullname ?  tr(item.institution.fullname).toLowerCase().includes(tr(element)) : false
          } else {
            includes_institution = tr(Enums.providerType[item.provider_type]).toLowerCase().includes(tr(element))
          }
          return includes_institution ? false : true
        })
        if (includes_title || includes_pasis_code || includes_code || includes_institution) {
          this.$set(item, 'searchActive', true)
          this.$set(item, 'showChildren', true)
        }
        let includesInChildren = this.searchChildrenData(item.children)
        if (includesInChildren) {
          this.$set(item, 'showChildren', true)
        }
        return (
          includes_title ||
          includes_pasis_code ||
          includes_code ||
          includes_institution ||
          includesInChildren
        )
      })
      return includes.length != 0
    },
    // tree search
     searchData() {
      if (!!this.activeSearch) {
        this.loading = true
        let filteredData = this.listData.filter((item) => {
          let title = this.$i18n.locale === 'lt' ? item.title_lt : item.title_en
          let search = this.search.toLowerCase().split(' ')
          // title
          let includes_title = false
          search.every((element) => {
            includes_title = tr(title).toLowerCase().includes(tr(element))
            return includes_title ? false : true
          })
          // pasis_code
          let includes_pasis_code = false
          search.every((element) => {
            includes_pasis_code = item.pasis_code
              ? item.pasis_code.toLowerCase().includes(element)
              : false
            return includes_pasis_code ? false : true
          })
          // code
          let includes_code = false
          search.every((element) => {
            includes_code = item.code
              ? item.code.toLowerCase().includes(element)
              : false
            return includes_code ? false : true
          })
          // institution
          let includes_institution = false
            search.every((element) => {
              if(item.provider_type === "amn"){
                includes_institution = item.institution?.fullname ? tr(item.institution.fullname).toLowerCase().includes(tr(element)) : false
              } else {
                includes_institution = tr(Enums.providerType[item.provider_type]).toLowerCase().includes(tr(element))
              }
              return includes_institution ? false : true
            })
          if (includes_title || includes_pasis_code || includes_code || includes_institution) {
            this.$set(item, 'searchActive', true)
          }
          let includesInChildren = this.searchChildrenData(item.children)
          if (includesInChildren) {
            this.$set(item, 'showChildren', true)
          }
          return (
            includes_title ||
            includes_pasis_code ||
            includes_code ||
            includes_institution ||
            includesInChildren
          )
        })
        this.listData = Object.assign([], filteredData)
        setTimeout(() => {
          this.loading = false
        }, 100)
      }
    },
    clearData() {
      this.loading = true
      this.activeSearch = ''
      this.search = ''
      this.page = 1
      this.listData = []
       this.loading = true
      this.getData(this.page)
    },
    async getData(page) {
      if (!this.customService) {
        this.listloading = true
        let mandateTypeId = this.formData.mandate_type_id
        let params = {
          page: page,
          search: this.activeSearch,
          visibility: this.formData.visibility
        }
        let byMandate = `mandate-types/${mandateTypeId}/actions`
        let byMandateInstitution = `mandate-types/${mandateTypeId}/institutions/${this.institutionId}/actions`
        let url = this.institutionId ? byMandateInstitution : byMandate
        // non-identified person
        if(['unidentified-physical', 'unidentified-juridical', 'unidentified-physical-juridical'].includes(this.providerType)){
          url = `mandate-types/${mandateTypeId}/unidentified/${this.providerType}/actions`
        }
        await this.$axios
          .get(url, { params: params })
          .then((res) => {
            let data = res.data.actions
            this.listData.push(...data);
            this.institutionData = res.data.institution
            this.isEmpty = res.data.is_empty
            this.totalPages = res.data.totalPages
            this.$emit('isEmpty', this.isEmpty)
            this.$emit('institutionData', this.institutionData)
            if (this.search) {
             this.searchData()
            }
          })
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.listloading = false
            this.loading = false
          })
      }
    },
    emmitClearAll() {
      this.clearAll(this.listData)
    },
    clearAll(itemArray) {
      itemArray.map((item) => {
        this.$set(item, 'selected', false)
        if (item.children.length > 0) {
          this.clearAll(item.children)
        }
      })
      this.$nextTick(() => {
          this.setTooltipParam()
      })
    },
    returnSelected(itemArray) {
      itemArray.map((item) => {
        this.returnSelected(item.children)
        if (item.selected) {
          let cloneItem = JSON.parse(JSON.stringify(item))
          cloneItem.parent_id = item.parent_id
          cloneItem.children = null
          if(item.children.length == 0){
            this.selectedData.push(cloneItem)
          }
        }
      })
    },
    addSelected() {
      this.selectedData = []
      this.returnSelected(this.listData)
      let services = this.selectedData
      this.$emit('selected', services)
    },
  },
}
</script>

<style lang="scss" scoped>
$background-color: rgba(#23f0c7, 0.7);
$text-color: #2c3e50;
.loading {
  position: absolute;
  bottom: 30%;
  left: 0;
  right: 0;
  width: 100px;
  margin: auto;
  padding: 10px 0;
  color: #fff;
  text-align: center;
  background: $text-color;
  border-radius: 4px;
}
</style>
